export const testAttributes = {
    SINGLE_CTA_CONTAINER: 'article_single_cta_container',
    CTA_BLOCK_CONTAINER: 'article_cta_block_container',
    SINGLE_CTA_HEADING_CONTAINER: 'single_cta_heading_container',
    SINGLE_CTA_HEADING: 'single_cta_heading',
    SINGLE_CTA_BUTTON: 'single_cta_button',
    SINGLE_CTA_BUTTON_ICON: 'single_cta_button_icon',
    SINGLE_CTA_IMAGE: 'single_cta_image',
    VARIANT_OUTLINED: 'variant-outlined',
};

export const defaultAttributes = {
    color: 'green',
    filled: 'filled',
    outlined: 'outlined',
};
